import { Flex, Text } from '@everlywell/ui-kit';
import DynamicIcon from 'components/DynamicIcon';
import { useFlags } from 'gatsby-plugin-launchdarkly';
import React from 'react';
import analytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import { useIsFeaturedEnabledByVWO } from 'utils/hooks/useIsFeatureEnabled/hooks/useVWO';
import { prepExtole } from 'utils/vendor/extole-lib';

export default function ReferAFriendEntryPoint() {
  // LD Flag
  const { hasReferAFriendPdp } = useFlags();
  // VWO Flag
  const { result: hasRafInPdp } = useIsFeaturedEnabledByVWO('hasRafInPdp');

  if (!hasReferAFriendPdp || !hasRafInPdp || typeof window === 'undefined') {
    return null;
  }

  prepExtole();

  if (window?.extole) {
    window.extole?.createZone({
      name: 'product',
      element_id: 'extole_zone_product',
    });
  }

  const trackClickEvent = () => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: 'Refer a Friend',
      },
    });
  };

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      data-testid="refer-a-friend-entry-point"
      backgroundColor="viridian.wash"
      borderRadius="xl"
      paddingY="3"
      paddingX={['6', null, '8']}
      gap="1"
      onClick={() => trackClickEvent()}
      sx={{
        span: {
          zIndex: 1,

          '&#extole_zone_product button.extole-cta-button': {
            backgroundColor: 'viridian.wash',
            color: 'viridian.base',
            padding: '1px',
            height: '24px',
            fontWeight: 'medium',

            '&:hover': {
              textDecoration: 'underline',
            },
          },
        },
      }}
    >
      <Flex gap="1" alignItems="center">
        <DynamicIcon icon="Gift" color="viridian.base" />
        <Text color="tints.black">Share with a friend, get rewarded</Text>
      </Flex>
      {/* Id expected by extole */}
      <span id="extole_zone_product"></span>
    </Flex>
  );
}
